/* eslint-disable import/prefer-default-export */
import { localStorageSet, localStorageGet } from './localStorage';

export function setAuth(
  id,
  username,
  email,
  password,
  phone,
  verified,
  addresses,
  meta,
  gender,
  industry,
  dateOfBirth,
  profilePhoto, // new
) {
  localStorageSet('auth.id', id);
  localStorageSet('auth.username', username);
  localStorageSet('auth.email', email);
  localStorageSet('auth.password', password);
  localStorageSet('auth.phone', phone);
  localStorageSet('auth.verified', verified);
  localStorageSet('auth.addresses', addresses);
  localStorageSet('auth.gender', gender);
  localStorageSet('auth.industry', industry);
  localStorageSet('auth.date_of_birth', dateOfBirth);
  localStorageSet('auth.profile_photo', profilePhoto);
  if (meta != null) {
    localStorageSet(
      'auth.has_agreed_to_receive_gogovan_updates',
      meta.has_agreed_to_receive_gogovan_updates,
    );
    localStorageSet(
      'auth.has_agreed_to_receive_third_parties_updates',
      meta.has_agreed_to_receive_third_parties_updates,
    );
  }

  return this;
}

export function getAuth() {
  const email = localStorageGet('auth.email', false);
  const password = localStorageGet('auth.password', false);
  const phone = localStorageGet('auth.phone', false);

  if (!((email || phone) && password)) {
    return false;
  }

  const id = localStorageGet('auth.id', false);
  const username = localStorageGet('auth.username', false);
  const verified = localStorageGet('auth.verified', false);
  const addresses = localStorageGet('auth.addresses', false);
  const gender = localStorageGet('auth.gender', false);
  const industry = localStorageGet('auth.industry', false);
  const dateOfBirth = localStorageGet('auth.date_of_birth', false);
  const receiveGogovanUpdates = localStorageGet(
    'auth.has_agreed_to_receive_gogovan_updates',
    false,
  );
  const receiveThirdPartiesUpdates = localStorageGet(
    'auth.has_agreed_to_receive_third_parties_updates',
    false,
  );

  const profilePhoto = localStorageGet('auth.profile_photo', false);

  return {
    id,
    email,
    password,
    username,
    phone,
    verified,
    addresses,
    profilePhoto,
    receiveGogovanUpdates,
    receiveThirdPartiesUpdates,
    gender,
    industry,
    dateOfBirth,
  };
}

export function authorizeRequest(json) {
  let auths = '';
  if (json === null) {
    auths = btoa(`${getAuth().email}:${getAuth().password}`);
    // auths = Buffer.from(`${getAuth().email}:${getAuth().password}`).toString('base64');
  } else {
    auths = btoa(`${json.user.email}:${json.user.password}`);
  }
  return `Basic ${auths}`;
}



// WEBPACK FOOTER //
// ./src/service/auth.js